import { MoreHorizontal } from "lucide-react";
import type { VisitListItem } from "@school-sales-ai/shared";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export type VisitModalState =
  | { kind: "reschedule"; visit: VisitListItem }
  | { kind: "cancel"; visit: VisitListItem }
  | { kind: "attendance"; visit: VisitListItem; status: "attended" | "no_show" }
  | null;

type Props = {
  visit: VisitListItem;
  onAction: (state: VisitModalState) => void;
};

export function VisitRowActions({ visit, onAction }: Props): React.JSX.Element | null {
  const isScheduled = visit.status === "scheduled";
  const isFuture = new Date(visit.startsAt).getTime() > Date.now();
  // Reschedule/cancel only make sense before the visit happens; a past
  // scheduled visit should be resolved via attendance instead.
  const canMove = isScheduled && isFuture;
  const canMarkAttendance = isScheduled;

  if (!canMove && !canMarkAttendance) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Acciones de la visita"
        className="rounded p-1.5 text-ink-400 hover:bg-ink-050 hover:text-ink-700"
      >
        <MoreHorizontal size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {canMove && (
          <>
            <DropdownMenuItem onSelect={() => onAction({ kind: "reschedule", visit })}>
              Reprogramar
            </DropdownMenuItem>
            <DropdownMenuItem
              className="text-red-600"
              onSelect={() => onAction({ kind: "cancel", visit })}
            >
              Cancelar visita
            </DropdownMenuItem>
          </>
        )}
        {canMarkAttendance && (
          <>
            <DropdownMenuItem
              onSelect={() => onAction({ kind: "attendance", visit, status: "attended" })}
            >
              Marcar asistió
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={() => onAction({ kind: "attendance", visit, status: "no_show" })}
            >
              Marcar no asistió
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
